const VERSION = "2536";
const APPLICATIONINSIGHTS_CONNECTION_STRING = "InstrumentationKey=d17fb568-c8a6-4f87-9b8f-b2576772587c;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/";
const LD_CLIENT_KEY= "6467ba37bc0ca91230519c17";
const G_MAPS_CLIENT_API_KEY= "AIzaSyCfTyGQsVeg0o3yZDNnJNrumBJCSX11on0";
const SITE_URL= "https://adventuregenie.com";
module.exports = {VERSION,APPLICATIONINSIGHTS_CONNECTION_STRING, LD_CLIENT_KEY, G_MAPS_CLIENT_API_KEY, SITE_URL}